import React, { useState } from 'react';
import { Button, Typography } from "@material-ui/core";
import {faFileImage, faThumbsUp} from "@fortawesome/free-solid-svg-icons";
import {faThumbsUp as faThumbsDownRegular} from "@fortawesome/free-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {faFile} from "@fortawesome/free-solid-svg-icons";
import {buildShapperPath} from "../../../helpers/Tools";

function ImageUploader({ onImageSelected, defaultValue = null, onImageRemoved = () => {}, label = "Image", positionPreview="above"}) {
    const [image, setImage] = useState(null);

    console.log("ImageUploader defaultValue", defaultValue);

    const handleChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            setImage(URL.createObjectURL(file));
            onImageSelected(file); // Appel vers le parent
        }
    };

    const handleRemove = () => {
        setImage(null);
        onImageRemoved(); // Appel vers le parent
    };

    React.useEffect(() => {

        //load static image if defaultValue is provided
        console.log("ImageUploader useEffect defaultValue", defaultValue);

        if (defaultValue) {
            defaultValue = buildShapperPath(defaultValue);
            setImage(defaultValue);
            onImageSelected(defaultValue); // Appel vers le parent
        }
    }, [defaultValue]);


    return (
        <div>
            {image && positionPreview === "below" && (
                <div style={{ marginTop: 16 }}>
                    <img src={image} alt="Aperçu" style={{ maxWidth: '150px', height: 'auto' }} />
                </div>
            )}
            <input
                accept="image/*"
                id="upload-image"
                type="file"
                style={{ display: 'none' }}
                onChange={handleChange}
            />
            <label htmlFor="upload-image">
                <Button variant="contained" component="span">
                    <FontAwesomeIcon icon={faFileImage} style={{ marginRight: 8 }} />
                    {label ? label : 'Image'}
                </Button>
            </label>

            {image && positionPreview === "above" && (
                <div style={{ marginTop: 16 }}>
                    <Typography variant="subtitle1">Aperçu :</Typography>
                    <img src={image} alt="Aperçu" style={{ maxWidth: '100%', height: 'auto' }} />
                </div>
            )}
        </div>
    );
}

export default ImageUploader;
